<template>
  <button
    v-wave
    class="template-card flex-none p-3.5 rounded-2xl bg-[#faf9ff] border-[1.5px] border-dashed border-[#c4b0ee] flex flex-col items-center justify-center gap-2 cursor-pointer text-primary hover:bg-primary-50 transition-colors"
    :class="kind === 'bundles' ? 'w-[200px]' : 'w-[160px]'"
    @click="$emit('click')"
  >
    <div class="w-9 h-9 rounded-full bg-[#edeafd] flex items-center justify-center">
      <i class="pi pi-plus text-base text-primary" />
    </div>
    <div class="text-sm font-medium text-center leading-tight">{{ label }}</div>
    <div class="text-[11px] text-primary-400 text-center">פרסום באתר</div>
  </button>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';

const props = defineProps({
  kind: {
    type: String as PropType<'bundles' | 'vouchers'>,
    required: true
  }
});

defineEmits<{ (e: 'click'): void }>();

const label = computed(() => (props.kind === 'bundles' ? 'חבילה חדשה' : 'סכום חדש'));
</script>
